import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import BUISNESSMAN from '../../../app/assets/images/business-man.webp'

const BusinessComponent = () => {
    // Create ref for scroll-triggered animation
    const componentRef = useRef(null);
    
    // Use inView hook for scroll animation trigger
    const isComponentInView = useInView(componentRef, { once: false, amount: 0.3 });
    
    // Animation variants
    const contentVariant = {
        hidden: { opacity: 0, x: -50 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } }
    };
    
    const imageVariant = {
        hidden: { opacity: 0, x: 50 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut", delay: 0.3 } }
    };
    
    return (
        <div className='min-h-[18rem] md:h-[350px] lg:h-[22rem] bg-[#ffb81226] pt-4 md:pt-8 mt-8 md:mt-16' ref={componentRef}>
            <div className='bg-yellow min-h-[16rem] md:h-72 flex'>
                <div className='flex flex-col md:flex-row w-full '>
                    <motion.div 
                        className='mt-8 md:mt-0 p-4 md:p-8 flex flex-col text-center md:text-left justify-center w-full md:w-[60%] lg:w-[70%] px-6 md:pl-10 lg:pl-40 gap-2 md:gap-4'
                        variants={contentVariant}
                        initial="hidden"
                        animate={isComponentInView ? "visible" : "hidden"}
                    >
                        <div className=' text-black font-bold text-2xl md:text-4xl lg:text-5xl'>The power of modern technology</div>
                        <div className='text-brownPrimary text-base md:text-xl lg:text-2xl'>
                            We develop effective, future-oriented iOS apps using the
                            latest tech, ensuring strong security for your 
                            sensitive information.
                        </div>
                    </motion.div>
                    <motion.div 
                        className='w-full md:w-[40%] lg:w-[30%] hidden md:flex justify-center md:-mt-4'
                        variants={imageVariant}
                        initial="hidden"
                        animate={isComponentInView ? "visible" : "hidden"}
                    >
                        <img src={BUISNESSMAN} className=' w-[50%] md:w-[70%]' />
                    </motion.div>
                </div>
            </div>
        </div>
    )
}

export default BusinessComponent
